import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        bonuses: {
          add_bonus: {
            header: 'HEADER',
            add_bonus: 'PLAYERS_BONUSES_ADD_BONUS',
            back: 'BACK',
            tabs: {
              from_file: {
                header: 'FILE_HEADER',
                description: 'FILE_DESCRIPTION',
                errors_in_file: 'FILE_ERROR',
              },
            },
          },
        },
      },
    },
  }));
}
